































  import {Component, Prop, Mixins, Watch} from 'vue-property-decorator';
import TerritoryType from '@/intefaces/TerritoryType';
import BaseCUModalComponentMixin from '@/mixins/BaseCUModalComponent';
import { AxiosResponse } from 'axios';
import { clone } from 'lodash';

@Component
export default class CreateTerritoryTypeForm extends Mixins(BaseCUModalComponentMixin) {
  @Prop({
    default: () => ({
      name: '',
      description: '',
      has_outlet: false,
      level: 1
    })
  })
  form!: {
    name: string;
    description: string;
    has_outlet: boolean;
    level: number;
  };

  @Prop()
  currentEntity!: TerritoryType;

  @Prop({ required: true })
  availableTerritoryTypes!: TerritoryType[];

  @Prop({default: false})
  hasOutlet!: boolean

  get createApi(): string {
    return '/territory-types';
  }
  get updateApi(): string {
    return `/territory-types/${this.currentEntity.id}`;
  }

  @Watch('form.has_outlet')
  visibleHasOutlet(newVal: any){
    if(!newVal && this.isUpdate){
      this.$emit('update:hasOutlet', false);
    }
  }

  get availableLevels(): any[] {
    let copyOfAvailableTerritoryTypes: Array<any> = clone(this.availableTerritoryTypes);
    copyOfAvailableTerritoryTypes.sort((a, b) => a.level - b.level);
    let levels: any[] = [];
    copyOfAvailableTerritoryTypes.forEach((value, index) => {
      if (this.isUpdate) {
        if (this.currentEntity.level === value.level) {
          levels.push({ name: `At level-${value.level} | Current Level`, id: value.level });
        } else {
          levels.push({ name: `At level-${value.level} | Swap with ${value.name}`, id: value.level });
        }
      }
      if (!this.isUpdate) {
        levels.push({ name: `At level-${value.level} | Before ${value.name}`, id: value.level });
        if (index === copyOfAvailableTerritoryTypes.length - 1) {
          levels.push({ name: `At level-${value.level + 1} | After ${value.name}`, id: value.level + 1 });
        }
      }
    });
    if (levels.length == 0) {
      levels.push({ name: 'level-1', id: 1 });
    }
    return levels;
  }
  set availableLevels(value) {}
  formReset(): any {
    this.form.name = '';
    this.form.description = '';
    this.form.has_outlet = false;
    this.form.level = 1;
    return this.form;
  }

  async afterCreate(response: AxiosResponse<any>): Promise<void> {
    this.$emit('created', response.data.territoryType);
  }

  afterUpdate(response: AxiosResponse<any>): void {
    this.$emit('updated', response.data.territoryType);
  }
}
